module.exports = __webpack_public_path__ + "img/fundhouse.5faaf166.png";